module.exports = __webpack_public_path__ + "img/address.abf895c5.svg";